import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class BackgroundAnimator {
	constructor() {
		this.bgImages = document.querySelectorAll(".block-background .background-image");
		if (!this.bgImages || this.bgImages.length === 0) {
			console.warn("BackgroundAnimator: No background element found.");
			return;
		}
		this.init();
	}

	init() {
		this.bgImages.forEach((bgImage) => {
            const zoom = 1.2;
			const image = bgImage.querySelector("img");
			if (!image || image.classList.contains("parallax")) {
				return;
			}

			gsap.set(image, {
				scale: zoom,
				transformOrigin: "center center",
			});

			const tlUp = gsap.timeline({
				scrollTrigger: {
					trigger: bgImage,
					start: "top bottom",
					end: "top top",
					scrub: true,
					markers: false,
				},
			});

			tlUp.to(image, {
				scale: 1,
				ease: "power1.out",
			});

			const tlDown = gsap.timeline({
				scrollTrigger: {
					trigger: bgImage,
					start: "top top",
					end: "bottom top",
					scrub: true,
					markers: false,
				},
			});

			tlDown.to(image, {
				scale: zoom,
				ease: "power1.in",
			});
		});
	}
}
